module.exports = __webpack_public_path__ + "static/media/keyresult_expnasion_arrow.8162c8a9.svg";